import React, { useState, useEffect } from 'react';
import PostHeader from '@components/PostHeader';
import PostMobile from '@components/PostMobile';
import '@styles/BlogBody.css';
const Postsalesforce4 = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for this specific post
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const post = {
      title: "Salesforce Marketing Cloud: Driving Marketing Success",
      date: "April 1, 2024",
      image: "/assets/FeedItems/d3r8BzBNFerYynuYPjw2.svg",
      summary: "Understand the features and benefits of Salesforce Marketing Cloud. Learn about email marketing, social media management, customer journey mapping, and analytics to drive marketing success.",
      path: "blog/technology/salesforce/post/postsalesforce4"
    };

    document.title = `${post.title} - Cloud CZR`;
    updateMetaTag('og:title', `${post.title} - Cloud CZR`);
    updateMetaTag('og:description', post.summary);
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'article');
    updateMetaTag('og:image', `${window.location.origin}${process.env.PUBLIC_URL}${post.image}`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', post.summary, false);
    updateMetaTag('twitter:title', `${post.title} - Cloud CZR`, false);
    updateMetaTag('twitter:description', post.summary, false);
  }, []);

  const post = {
    title: "Salesforce Marketing Cloud: Driving Marketing Success",
    date: "April 1, 2024",
    image: "/assets/FeedItems/byz2.svg",
    summary: "Understand the features and benefits of Salesforce Marketing Cloud. Learn about email marketing, social media management, customer journey mapping, and analytics to drive marketing success.",
    path: "blog/technology/salesforce/post/postsalesforce4"
  };
  return (
    <div>
      {isDesktop ? (
        <PostHeader post={post} config={{ width: '400px', height: '400px' }} />
      ) : (
        <PostMobile post={post} config={{ width: '400px', height: '400px' }} />
      )}
      <div class="body-gold">
        <p>
          Salesforce Marketing Cloud is a powerful marketing automation platform that helps businesses create, manage, and optimize their marketing campaigns. It provides a range of tools and features to drive marketing success and improve customer engagement.
        </p>
        <h2>Key Features of Marketing Cloud</h2>
        <p>
          Marketing Cloud offers features such as email marketing, social media management, customer journey mapping, and analytics. These tools enable marketers to create personalized campaigns, track performance, and make data-driven decisions.
        </p>
        <h2>Email Marketing</h2>
        <p>
          Marketing Cloud's email marketing feature allows you to create and send targeted email campaigns. You can segment your audience, personalize content, and track engagement metrics to optimize your email marketing efforts.
        </p>
        <h2>Social Media Management</h2>
        <p>
          The social media management feature enables you to manage your social media presence across multiple platforms. You can schedule posts, monitor conversations, and analyze performance to improve your social media strategy.
        </p>
        <h2>Customer Journey Mapping</h2>
        <p>
          Marketing Cloud's customer journey mapping feature allows you to create personalized customer journeys based on individual behaviors and preferences. This helps you deliver relevant content and experiences at every stage of the customer lifecycle.
        </p>
        <p>
          Salesforce Marketing Cloud is a comprehensive solution that can help businesses drive marketing success and improve customer engagement. By leveraging its powerful features and tools, you can create effective marketing campaigns and achieve better results.
        </p>
      </div>
    </div>
  );
};

export default Postsalesforce4;